import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14,
  _t15,
  _t16,
  _t17,
  _t18,
  _t19;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.includes.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import * as dayjs from 'dayjs';
import getTranslation from './translations.js';
import css from './style.pcss';
import ArrowDownIcon from "../../common/images/arrow-down-white.svg";
var eventTypes = ['jump', 'dressage', 'drive', 'distance'];
var HorseSportResults = /*#__PURE__*/function (_LitElement) {
  _inherits(HorseSportResults, _LitElement);
  function HorseSportResults() {
    var _this;
    _classCallCheck(this, HorseSportResults);
    _this = _callSuper(this, HorseSportResults);
    _this.language = 'lu';
    _this.location = window.location.origin;
    if (process.env.NODE_ENV === 'development') {
      _this.location = 'http://localhost:8080';
    }
    _this.openedEventBoxes = [];
    _this.type = 'jump';
    return _this;
  }
  _createClass(HorseSportResults, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(HorseSportResults.prototype), "connectedCallback", this).call(this);
      this.fetchData();
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this2 = this;
      fetch('http://localhost:8080/api/horse-sport').then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        return _this2.data = resp;
      });
    }
  }, {
    key: "renderResults",
    value: function renderResults(event) {
      // const event = this.data.filter(event => parseInt(event.id, 10) === parseInt(id, 10))[0];
      var ret = null;
      switch (event.type) {
        case 'jump':
          ret = this.renderJumpResults(event);
          break;
        case 'dressage':
          ret = this.renderDressageResults(event);
          break;
        case 'drive':
          ret = this.renderDriveResults(event);
          break;
        case 'distance':
          ret = this.renderDistanceResults(event);
          break;
        default:
      }
      return ret;
    }
  }, {
    key: "renderDistanceResults",
    value: function renderDistanceResults(event) {
      if (!event || !event.results) return null;
      var startDate = dayjs(event.startDate);
      return event.results.map(function (dayResults, day) {
        if (!dayResults) return null;
        return html(_t || (_t = _`
            <div class="horse-sport-results__content">
                <h1 class="horse-sport-results__title">${0} - ${0}. Dag</h1>
                <table class="horse-sport-results__table">
                    <thead class="horse-sport-results__thead">
                        <tr>
                            <td class="horse-sport-results__thead-td">Name</td>
                            <td class="horse-sport-results__thead-td">HorseName</td>
                            <td class="horse-sport-results__thead-td">Position</td>
                            <td class="horse-sport-results__thead-td horse-sport-results--hide">Participants</td>
                            <td class="horse-sport-results__thead-td">Prufung</td>
                            <td class="horse-sport-results__thead-td">Average</td>
                            <td class="horse-sport-results__thead-td">ResultTime</td>
                        </tr>
                    </thead>
                    <tbody>
                        ${0}

                    </tbody>
                </table>

                <table class="horse-sport-results__table horse-sport-results__table--mobile">
                    <tbody>
                    ${0}
                    </tbody>
                </table>
            </div>
            `), startDate.add(day, 'day').format('DD.MM.YYYY'), day + 1, dayResults.map(function (result) {
          return html(_t2 || (_t2 = _`
                            <tr>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td horse-sport-results--hide">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            `), result.name, result.horseName, result.position, result.participants, result.prufung, result.average, result.resultTime);
        }), dayResults.map(function (result, i) {
          return html(_t3 || (_t3 = _`
                            ${0}
                            <tr>
                                <td class="horse-sport-results__thead-td">Name</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">HorseName</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">Position</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">Participants</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">Prufung</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">Average</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">ResultTime</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            `), i > 0 ? html(_t4 || (_t4 = _`<tr style="height:10px"></tr>`)) : null, result.name, result.horseName, result.position, result.participants, result.prufung, result.average, result.resultTime);
        }));
      });
    }
  }, {
    key: "renderDriveResults",
    value: function renderDriveResults(event) {
      if (!event || !event.results) return null;
      var startDate = dayjs(event.startDate);
      return event.results.map(function (dayResults, day) {
        if (!dayResults) return null;
        return html(_t5 || (_t5 = _`
            <div class="horse-sport-results__content">
                <h1 class="horse-sport-results__title">${0} - ${0}. Dag</h1>
                <table class="horse-sport-results__table">
                    <thead class="horse-sport-results__thead">
                        <tr>
                            <td class="horse-sport-results__thead-td">Name</td>
                            <td class="horse-sport-results__thead-td">HorseName</td>
                            <td class="horse-sport-results__thead-td">Position</td>
                            <td class="horse-sport-results__thead-td">Participants</td>
                            <td class="horse-sport-results__thead-td">Description</td>
                            <td class="horse-sport-results__thead-td">Prufung</td>
                            <td class="horse-sport-results__thead-td">PenaltyPoints</td>
                        </tr>
                    </thead>
                    <tbody>
                        ${0}

                    </tbody>
                </table>

                <table class="horse-sport-results__table horse-sport-results__table--mobile">
                    <tbody>
                        ${0}
                    </tbody>
                </table>
            </div>
            `), startDate.add(day, 'day').format('DD.MM.YYYY'), day + 1, dayResults.map(function (result) {
          return html(_t6 || (_t6 = _`
                            <tr>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            `), result.name, result.horseName, result.position, result.participants, result.description, result.prufung, result.penaltyPoints);
        }), dayResults.map(function (result, i) {
          return html(_t7 || (_t7 = _`
                            ${0}
                            <tr>
                                <td class="horse-sport-results__thead-td">Name</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">HorseName</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">Position</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">Participants</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">Description</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">Prufung</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">PenaltyPoints</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            `), i > 0 ? html(_t8 || (_t8 = _`<tr style="height:10px"></tr>`)) : null, result.name, result.horseName, result.position, result.participants, result.description, result.prufung, result.penaltyPoints);
        }));
      });
    }
  }, {
    key: "renderJumpResults",
    value: function renderJumpResults(event) {
      if (!event || !event.results) return null;
      var startDate = dayjs(event.startDate);
      return event.results.map(function (dayResults, day) {
        if (!dayResults) return null;
        return html(_t9 || (_t9 = _`
            <div class="horse-sport-results__content">
                <h1 class="horse-sport-results__title">${0} - ${0}. Dag</h1>
                <table class="horse-sport-results__table">
                    <thead class="horse-sport-results__thead">
                        <tr>
                            <td class="horse-sport-results__thead-td">Name</td>
                            <td class="horse-sport-results__thead-td">Horse name</td>
                            <td class="horse-sport-results__thead-td">Height</td>
                            <td class="horse-sport-results__thead-td">GPLR</td>
                            <td class="horse-sport-results__thead-td">Position</td>
                            <td class="horse-sport-results__thead-td">Participants</td>
                        </tr>
                    </thead>
                    <tbody>
                        ${0}

                    </tbody>
                </table>

                <table class="horse-sport-results__table horse-sport-results__table--mobile">
                    <tbody>
                        ${0}
                    </tbody>
                </table>
            </div>
            `), startDate.add(day, 'day').format('DD.MM.YYYY'), day + 1, dayResults.map(function (result) {
          return html(_t10 || (_t10 = _`
                            <tr>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            `), result.name, result.horseName, result.height, result.GPLR, result.position, result.participants);
        }), dayResults.map(function (result, i) {
          return html(_t11 || (_t11 = _`
                            ${0}
                            <tr>
                                <td class="horse-sport-results__thead-td">Name</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">HorseName</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">Height</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">GPLR</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">Position</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">Participants</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            `), i > 0 ? html(_t12 || (_t12 = _`<tr style="height:10px"></tr>`)) : null, result.name, result.horseName, result.height, result.GPLR, result.position, result.participants);
        }));
      });
    }
  }, {
    key: "renderDressageResults",
    value: function renderDressageResults(event) {
      if (!event || !event.results) return null;
      var startDate = dayjs(event.startDate);
      return event.results.map(function (dayResults, day) {
        if (!dayResults) return null;
        console.log('DAYRS', dayResults, day);
        return html(_t13 || (_t13 = _`
            <div class="horse-sport-results__content">
                <h1 class="horse-sport-results__title">${0} - ${0}. Dag</h1>
                <table class="horse-sport-results__table">
                    <thead class="horse-sport-results__thead">
                        <tr>
                            <td class="horse-sport-results__thead-td">Name</td>
                            <td class="horse-sport-results__thead-td">HorseName</td>
                            <td class="horse-sport-results__thead-td">Position</td>
                            <td class="horse-sport-results__thead-td">Participants</td>
                            <td class="horse-sport-results__thead-td">Description</td>
                            <td class="horse-sport-results__thead-td">WN</td>
                            <td class="horse-sport-results__thead-td">Percentage</td>
                            <td class="horse-sport-results__thead-td">Note</td>
                        </tr>
                    </thead>
                    <tbody>
                        ${0}
                    </tbody>
                </table>

                <table class="horse-sport-results__table horse-sport-results__table--mobile">
                    <tbody>
                    ${0}
                    </tbody>
                </table>
            </div>
            `), startDate.add(day, 'day').format('DD.MM.YYYY'), day + 1, dayResults.map(function (result) {
          return html(_t14 || (_t14 = _`
                            <tr>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            `), result.name, result.horseName, result.position, result.participants, result.description, result.WN, result.percentage, result.note);
        }), dayResults.map(function (result, i) {
          return html(_t15 || (_t15 = _`
                            ${0}
                            <tr>
                                <td class="horse-sport-results__thead-td">Name</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">HorseName</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">Position</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">Participants</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">Description</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">WN</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">Percentage</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            <tr>
                                <td class="horse-sport-results__thead-td">Note</td>
                                <td class="horse-sport-results__td">${0}</td>
                            </tr>
                            `), i > 0 ? html(_t16 || (_t16 = _`<tr style="height:10px"></tr>`)) : null, result.name, result.horseName, result.position, result.participants, result.description, result.WN, result.percentage, result.note);
        }));
      });
    }
  }, {
    key: "onChangeType",
    value: function onChangeType(value) {
      this.type = value;
      // const firstEvent = this.data.filter(event => event.type === this.type)[0];
      // if (!firstEvent) {
      this.selectedEvent = null;
      //     return;
      // }
      // this.selectedEvent = firstEvent.id;
    }
  }, {
    key: "openEventBox",
    value: function openEventBox(id) {
      if (this.openedEventBoxes.includes(id)) {
        this.openedEventBoxes = this.openedEventBoxes.filter(function (eid) {
          return eid !== id;
        });
      } else {
        this.openedEventBoxes = [].concat(_toConsumableArray(this.openedEventBoxes), [id]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      console.log('info', this.type, this.data, this.selectedEvent);
      var events = [];
      var filteredEvents = this.data;
      if (this.type) {
        filteredEvents = filteredEvents.filter(function (e) {
          return e.type === _this3.type;
        });
      }
      return html(_t17 || (_t17 = _`
            <style>${0}</style>
            <div class="horse-sport-results__container">
                <div class="horse-sport-results__tabs-container">
                    ${0}
                </div>
                    ${0}
            </div>
        `), css, eventTypes.map(function (type) {
        return html(_t18 || (_t18 = _`<div @click=${0} class="horse-sport-results__tab ${0}">${0}</div>`), function (e) {
          return _this3.onChangeType(type);
        }, _this3.type === type ? 'active' : '', getTranslation(type, _this3.language));
      }), filteredEvents.map(function (event) {
        var results = _this3.openedEventBoxes.includes(event.id) ? _this3.renderResults(event) : null;
        return html(_t19 || (_t19 = _`
                            <div class="horse-sport-results__category horse-sport-results__category--arrow" style="background-image: url('${0}');" @click=${0}>${0} | ${0}</div>
                            ${0}
                        `), ArrowDownIcon, function () {
          return _this3.openEventBox(event.id);
        }, event.location, event.category, results);
      }));
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: Array
        },
        selectedEvent: {
          type: String
        },
        language: {
          type: String
        },
        type: {
          type: String
        },
        openedEventBoxes: {
          type: Array
        }
      };
    }
  }]);
  return HorseSportResults;
}(LitElement);
export { HorseSportResults as default };
window.customElements.define('horse-sport-results', HorseSportResults);